const _ = require('lodash');

/**
 * Formats the jsonschema data into a stringed value
 * @param {Array<ValidationError>} errors the json schema errors
 * @returns {string} in format of string:string or string:string,args
 * @memberof formatters
 */
const nameArguments = (errors) => {
  const exclusionList = ['oneOf', 'anyOf', 'const'];
  const orderList = ['type', 'required'];

  const formatError = ({ name, path, argument }) => {
    const result = _.kebabCase(name);
    const pathStr = _.isEmpty(path) ? '' : _.join(path, '.');
    const argStr = _.isArray(argument) ? _.join(argument, ',') : argument;
    if (result === 'required' && (pathStr || '') !== '') {
      return `${result}:${pathStr}.${argStr}`;
    }
    return `${result}:${((pathStr || '') !== '' ? `${pathStr},${argStr}` : `${argStr}`)}`;
  };

  const isInList = (error, list) => {
    const {
      name,
    } = error || {};
    return _.includes(list, name);
  };
  // default to the incoming
  let errorsToUse = errors;
  // partition over the excluded list
  const [
    filteredErrors,
    excludedErrors,
  ] = _.partition(errors, (error) => !isInList(error, exclusionList));
  // if we have any in the excluded list, then grab the 1st ordered item
  if (!_.isEmpty(excludedErrors) && !_.isEmpty(filteredErrors)) {
    errorsToUse = [_.head(_.orderBy(filteredErrors, [(error) => {
      const { name } = error || {};
      return _.indexOf(orderList, name);
    }]))];
  }

  return _(errorsToUse).map(formatError).join('|').valueOf();
};

module.exports = nameArguments;
